module.exports = __webpack_public_path__ + "static/media/skyber_case.15675319.png";